/* AD-03 · PILOT PROVISIONER
   ADM-26/27/28: §62 runbook, pilot dashboard (readiness, activity, gift health,
   Google health, success measures), audited renew/convert/offboard — never
   silent removal. Runs after the build, per the deferral decision. */
import { ListRow, Tile, Tiles } from '@/ui'
import { useAdmin } from './AdminShell'
import Mark from './Mark'

export default function AD03Pilot() {
  const p = useAdmin().pilot
  return (
    <section data-frame="AD-03" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Pilote Valessio — provisionnement</h2>
      <div>
        {p.steps.map(s => (
          <ListRow key={s.n} title={`${s.n} · ${s.label}`}
            end={s.mark ? <Mark cell={s.mark} /> : <span>—</span>} />
        ))}
      </div>
      <Tiles>
        {p.tiles.map(t => <Tile key={t.label} label={t.label} value={t.value} hint={t.hint} />)}
      </Tiles>
    </section>
  )
}
